import { render, staticRenderFns } from "./Followers.vue?vue&type=template&id=9206fdc2&"
import script from "./Followers.vue?vue&type=script&lang=ts&"
export * from "./Followers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports